function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import equal from 'deep-equal';
import ComponentPage from '../ComponentPage/ComponentPage';
import SideNavigationLocal from '../SideNavigationLocal/SideNavigationLocal';
import QuickLinks from '../QuickLinks/QuickLinks';
import "./LocalDocumentationPage.css";

var LocalDocumentationPage = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LocalDocumentationPage, _Component);

  LocalDocumentationPage.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var isEqual = equal(nextProps.documentationData, prevState.documentationData);

    if (!isEqual) {
      var updatedCurrent = nextProps.documentationData[prevState.current.componentName];
      return {
        documentationData: nextProps.documentationData,
        current: updatedCurrent
      };
    }

    return null;
  };

  function LocalDocumentationPage(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleNavigation = function (evt, data) {
      if (data && (data.componentName || data.name)) {
        _this.setState({
          current: _this.state.documentationData[data.componentName || data.name]
        });
      }
    };

    _this.state = {
      documentationData: props.documentationData,
      current: _this.getFirstItem(_this.props.documentationData)
    };
    return _this;
  }

  var _proto = LocalDocumentationPage.prototype;

  _proto.getFirstItem = function getFirstItem(data) {
    if (!data) {
      return {};
    }

    var sortedKeys = Object.keys(data).sort();
    return data[sortedKeys[0]] || {};
  };

  _proto.getNavigationItems = function getNavigationItems(data) {
    var navItems = [];

    if (data) {
      for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
        var item = _Object$keys[_i];
        navItems.push(data[item]);
      }
    }

    return navItems;
  };

  _proto.render = function render() {
    var _this$state$current = this.state.current,
        bundleSize = _this$state$current.bundleSize,
        componentName = _this$state$current.componentName,
        demos = _this$state$current.demos,
        multiDemos = _this$state$current.multiDemos,
        description = _this$state$current.description,
        events = _this$state$current.events,
        importAll = _this$state$current.importAll,
        isDefaultExport = _this$state$current.isDefaultExport,
        name = _this$state$current.name,
        properties = _this$state$current.properties,
        quickLinks = _this$state$current.quickLinks,
        repoData = _this$state$current.repoData,
        sections = _this$state$current.sections,
        support = _this$state$current.support,
        tag = _this$state$current.tag,
        type = _this$state$current.type,
        family = _this$state$current.family,
        category = _this$state$current.category;
    var useIframe = this.props.useIframe;
    var navigationItems = this.getNavigationItems(this.state.documentationData);
    return /*#__PURE__*/React.createElement("div", {
      className: "LocalDocumentationPage"
    }, /*#__PURE__*/React.createElement("header", {
      className: "LocalDocumentationPage__Header"
    }, repoData && /*#__PURE__*/React.createElement("div", {
      className: "LocalDocumentationPage__header-flex container-fluid"
    }, repoData.qualifiedName && /*#__PURE__*/React.createElement("div", {
      className: "LocalDocumentationPage__header-flex-item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "LocalDocumentationPage__repo-name"
    }, repoData.qualifiedName)), repoData.url && /*#__PURE__*/React.createElement("div", {
      className: "LocalDocumentationPage__header-flex-item"
    }, /*#__PURE__*/React.createElement("a", {
      title: "View on Github",
      className: "LocalDocumentationPage__github-link pull-right small",
      href: repoData.url
    }, /*#__PURE__*/React.createElement("svg", {
      version: "1.1",
      x: "0px",
      y: "0px",
      width: "24",
      viewBox: "0 0 36 36",
      style: {
        enableBackground: 'new 0 0 36 36'
      }
    }, /*#__PURE__*/React.createElement("path", {
      style: {
        fill: 'currentColor'
      },
      d: "M18,2C9.2,2,2,9.3,2,18.4C2,25.7,6.6,31.8,12.9,34 c0.8,0.2,1.1-0.4,1.1-0.8c0-0.4,0-1.4,0-2.8c-4.5,1-5.4-2.2-5.4-2.2c-0.7-1.9-1.8-2.4-1.8-2.4c-1.5-1,0.1-1,0.1-1 c1.6,0.1,2.5,1.7,2.5,1.7c1.4,2.5,3.7,1.8,4.7,1.4c0.1-1.1,0.6-1.8,1-2.2c-3.6-0.4-7.3-1.8-7.3-8.1c0-1.8,0.6-3.3,1.6-4.4 c-0.2-0.4-0.7-2.1,0.2-4.3c0,0,1.3-0.4,4.4,1.7c1.3-0.4,2.6-0.5,4-0.6c1.4,0,2.7,0.2,4,0.6c3.1-2.1,4.4-1.7,4.4-1.7 c0.9,2.3,0.3,3.9,0.2,4.3c1,1.1,1.6,2.6,1.6,4.4c0,6.3-3.7,7.7-7.3,8.1c0.6,0.5,1.1,1.5,1.1,3c0,2.2,0,4,0,4.5 c0,0.4,0.3,0.9,1.1,0.8C29.4,31.8,34,25.7,34,18.4C34,9.3,26.8,2,18,2z"
    })), /*#__PURE__*/React.createElement("span", {
      className: "hidden-xs LocalDocumentationPage__github-text"
    }, ' View On Github'))))), /*#__PURE__*/React.createElement("nav", {
      className: "LocalDocumentationPage__SideNav"
    }, /*#__PURE__*/React.createElement(SideNavigationLocal, {
      items: navigationItems,
      name: name,
      onClick: this.handleNavigation,
      family: family,
      category: category
    })), /*#__PURE__*/React.createElement("main", {
      className: "LocalDocumentationPage__Main"
    }, /*#__PURE__*/React.createElement(ComponentPage, {
      bundleSize: bundleSize,
      componentName: componentName,
      demos: demos,
      multiDemos: multiDemos,
      importAll: importAll,
      isDefaultExport: isDefaultExport,
      events: events,
      local: true,
      name: name,
      description: description,
      properties: properties,
      repoData: repoData,
      sections: sections,
      tag: tag,
      type: type,
      family: family,
      category: category,
      support: support,
      useIframe: useIframe
    }, this.props.children)), /*#__PURE__*/React.createElement("aside", {
      className: "LocalDocumentationPage__Links"
    }, /*#__PURE__*/React.createElement(QuickLinks, {
      links: quickLinks,
      type: type
    })));
  };

  return LocalDocumentationPage;
}(Component);

LocalDocumentationPage.propTypes = {
  documentationData: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  useIframe: PropTypes.bool
};
export default LocalDocumentationPage;
//# sourceMappingURL=LocalDocumentationPage.js.map